import { createClient, type SanityClient } from 'next-sanity'
import imageUrlBuilder from '@sanity/image-url'
import type { SanityImage } from '../app/types/sanity'

// Sanity client with optimized configuration
export const client: SanityClient = createClient({
  projectId: 'zxyy14de',
  dataset: 'production',
  apiVersion: '2025-10-03',
  useCdn: true,
  // Optimize for better performance and privacy
  perspective: 'published',
  stega: false, // Disable stega to reduce bundle size
  // Reduce cookie usage
  token: process.env.SANITY_API_TOKEN,
})

// Lazy load image URL builder to reduce initial bundle size
let builder: ReturnType<typeof imageUrlBuilder> | null = null;

const getBuilder = () => {
  if (!builder) {
    builder = imageUrlBuilder(client);
  }
  return builder;
};

// Optimized urlFor function with better image processing
export const urlFor = (source: SanityImage) => {
  return getBuilder()
    .image(source)
    .format('webp') // Use WebP format for better compression
    .quality(95) // High quality to preserve original image quality
    .fit('crop') // Optimize for better loading
}
